//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

//MUI :
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import KeyboardTabIcon from '@mui/icons-material/KeyboardTab';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import SkipNextIcon from '@mui/icons-material/SkipNext';

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { commentaireSlice } from "../../store/commentaireSlice.js";
import { getCommentaire } from "../../store/selectors.js";

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

//Translate utils :
import { translator } from "../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

function Comments({ comList, client, readOnly }) {

    let com = useSelector(getCommentaire);
    const lang = useSelector(getLang) //global state : language
    const dispatch = useDispatch();

    function handleChange(newValue) {
        dispatch(commentaireSlice.actions.setCommentaire(newValue));

    }

    return (

        <div className="comments">
            {readOnly === false ?
                <div className="comments-edit">
                    <TextField
                        className="comments-edit-field"
                        fullWidth
                        id="new-commentaire"
                        label={translator("Commentaire", lang, "confirmResaComment")}
                        variant="outlined"
                        value={com}
                        onChange={(e) => handleChange(e.target.value)} />
                </div>
                : null}
            <div className="comments-history">
                <div>
                    {
                        comList.length > 0 ?
                            comList.map((com, index) =>
                                <div key={index} className="comments-history-line">
                                    <p className="comments-history-line-text">{com.commentaire}</p>
                                    <p className="comments-history-line-infos">{`envoyé par ${com.by_client === true ? client.prenom : "Wally Glisse"}, ${dayjs(com.created).format("DD/MM/YYYY HH:mm")}`}</p>

                                </div>
                            )
                            :
                            null
                    }
                </div>

            </div>

        </div>
    );
}

export default Comments;